//Font action
import { FontActionTypes, AddFonts, ModifyFonts, DeleteFonts } from 'Actions/ActionTypes/fonts';
import { Font, Id } from 'NSwag/ServerClient/Client.nswag';

export const addFonts = (fonts: Font[]): AddFonts => ({
    type: FontActionTypes.AddFonts as FontActionTypes.AddFonts,
    fonts
});

export const modifyFonts = (fonts: Font[]): ModifyFonts => ({
    type: FontActionTypes.ModifyFonts as FontActionTypes.ModifyFonts,
    fonts
});

export const deleteFonts = (ids: Id[]): DeleteFonts => ({
    type: FontActionTypes.DeleteFonts as FontActionTypes.DeleteFonts,
    ids
});

export type FontAction = ReturnType<typeof addFonts | typeof modifyFonts | typeof deleteFonts>